import { createAction } from 'redux-act';

import { RealmLanguage, RealmSDK } from './types';

const NAME = 'sdks/';

export const setSelectedLanguage = createAction<RealmLanguage>(`${NAME}set realm language`);

export const setSelectedSDK = createAction<RealmSDK>(`${NAME}set realm sdk`);
